import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BaseComponent} from '../../../core/component/base.component';
import {ConfigurationParameters} from '../../service/resource/configuration-parameters';
import {ConfigurationParametersService} from '../../service/configuration-parameters.service';
import {AlertService} from '../../../core/service/alert.service';
import {MessageService} from '../../../core/service/message.service';
import {SecurityService} from '../../../core/service/security.service';
import {LoggerService} from '../../../service/logger.service';

@Component({
    selector: 'app-configuration-parameters',
    templateUrl: './configuration-parameters.component.html',
    standalone: false
})
export class ConfigurationParametersComponent extends BaseComponent<ConfigurationParameters> implements OnInit {

  codes = [
    {value: 'EMPLOYER_CONTRIBUTION_RATE', label: 'Porcentaje Contribución Patrono'},
    {value: 'SOCIAL_SECURITY_RATE', label: 'Porcentaje Cargas Sociales'},
    {value: 'SOLIDARITY_CONTRIBUTION_RATE', label: 'Porcentaje Patronal Asociación Solidaria'}
  ];

  constructor(private globalConfigurationService: ConfigurationParametersService,
              private alertService: AlertService,
              protected messageService: MessageService,
              protected logService: LoggerService,
              protected router: Router,
              protected securityService: SecurityService) {
    super(globalConfigurationService, 'configurationParameters', alertService, router, securityService, messageService, logService);
    this.sortBy = ['code'];
    this.sortOrder = 'asc';
  }

  getModelInstance(): ConfigurationParameters {
    return new ConfigurationParameters();
  }

  clearFormErrors(): Map<string, string> {
    return new Map<string, string>();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  getCodeLabel(code: string | undefined): string {
    if (!code) {
      return '';
    }
    const found = this.codes.find(c => c.value === code);
    return found ? found.label : code;
  }
}
